import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID, APP_INITIALIZER, ErrorHandler, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

// Modulo Http
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// Interceptor
import { TokenInterceptor } from './shared/interceptors/token.interceptors';

// Se importa el módulo de Login para poder utilizar los NGX-Modal en servicios
import { LoginModule } from './login/login.module';
// Modulo Shared
import { SharedModule } from './shared/shared.module';

// Locale - Idioma de Angular (datePipe, etc.)
// https://github.com/angular/angular/tree/master/packages/common/locales
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { MetaModule } from '@ngx-meta/core';
registerLocaleData(es);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    LoginModule,
    SharedModule,
    MetaModule.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-CO' },
    // Sentry
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => {},
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
